import React from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  dominationServicesPageAdditionalMeta,
  dominationServicesPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import DominationServicesPageMainContainer from '../../components/services/DominationServicesPageMainContainer';
import HeaderBanner from '../../components/general/HeaderBanner';
import AltHeader from '../../components/general/AltHeader';
import FooterComponent from '../../components/footer/FooterComponent';

function DominationServicesPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Domination Services'
        desc={`Explore the professional domination services offered by ${CompanyName}. Mistress Maria provides tailored Femdom experiences—both real-time and online—designed to break, train, and control obedient submissives across Norfolk and beyond.`}
        keywords={`Mistress Maria domination services, Dominatrix Norfolk, Femdom sessions, BDSM Mistress UK, online domination, real-time BDSM, submissive training, sissy training, pro Domme services, mature Dominatrix, Norfolk BDSM`}
        additionalMeta={dominationServicesPageAdditionalMeta}
        structuredData={dominationServicesPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 dark:bg-colour2 text-colour2 dark:text-colour1 font-poppins'>
        <div className='grid h-fit'>
          {/* Alt */}
          <AltHeader />

          {/* Navigation */}
          <Navbar />

          {/* Header */}
          <header className='grid pt-12'>
            <HeaderBanner message={`Domination/Dominatrix Services`} />

            <section className='grid w-full'>
              <div className='grid w-full px-6 lg:container lg:mx-auto gap-8 py-8 text-lg tracking-wider'>
                <p>
                  I am Mistress Maria — the embodiment of elegance, authority,
                  and absolute control. Based in Norfolk, I offer elite Femdom
                  experiences crafted for those who yearn to submit. My sessions
                  are not simply play — they are rituals of power exchange,
                  designed to strip away your ego and reveal your obedient core.
                </p>
                <p>
                  From psychological domination and corporal punishment to sissy
                  training, bondage, and roleplay, I shape each encounter around
                  your limits and my desires. Sessions are available in person
                  or online via WhatsApp, email, or text. Whether you're an
                  experienced submissive or a curious newcomer, prepare to be
                  seen, used, and redefined. Your surrender begins now — serve
                  with purpose or don’t bother at all.
                </p>
              </div>
            </section>
          </header>
        </div>

        {/* Main page content */}
        <DominationServicesPageMainContainer />

        {/* Footer */}
        <FooterComponent />
      </div>
    </>
  );
}

export default DominationServicesPage;
